import { render, staticRenderFns } from "./RedirectConfigCode.vue?vue&type=template&id=07af6b4a&scoped=true&"
import script from "./RedirectConfigCode.vue?vue&type=script&lang=js&"
export * from "./RedirectConfigCode.vue?vue&type=script&lang=js&"
import style0 from "./RedirectConfigCode.vue?vue&type=style&index=0&id=07af6b4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07af6b4a",
  null
  
)

export default component.exports